import { SectionOne } from "../components/feature/ServiceDetail";

export default function ServiceDetailPage()
{
    return(
        <section className="">
            <SectionOne/>
        </section>
    );
}